import React from 'react';
import {StyledGrid} from 'presentation/components';
import lifeStyleLove from 'presentation/assets/images/lifestyle-love.svg';
import {Card, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {EmptyStateProps} from './types';

const {emptyState} = translations['pt-br'].privateFlow.guideFlow.favoriteDoctors;

const EmptyState = ({isMobile}: EmptyStateProps) => {
	return (
		<StyledGrid.Root
			p={isMobile ? 2 : 4}
			alignContent="flex-start"
			justifyContent="center"
			height="100%">
			<StyledGrid.Item key={0} sm={12} md={12} lg={8}>
				<Card elevation={0}>
					<Stack gap={2} alignItems="center" p={3}>
						<img
							width={128}
							height={128}
							src={lifeStyleLove}
							alt="Pessoa sentada fazendo um coração com os braços"
						/>
						<Typography variant="h6">{emptyState.title}</Typography>
						<Typography variant="body1" textAlign="center">
							{emptyState.description}
						</Typography>
					</Stack>
				</Card>
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
};

export {EmptyState};
